import { memberDetailsQuery } from '@/queries/memberDetails.queries';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

const useMemberDetails = (options?: { staleTime?: number; enabled?: boolean }) => {
  const enabled = options?.enabled ?? true;
  const memberDetailsQueryResult = useQuery({
    ...memberDetailsQuery(),
    enabled,
    refetchInterval: 120 * 1000,
    ...(options?.staleTime !== undefined && { staleTime: options.staleTime }),
  });

  const { data: memberDetails } = memberDetailsQueryResult;

  useEffect(() => {
    if (
      enabled &&
      memberDetails == null &&
      memberDetailsQueryResult.isFetching === false &&
      memberDetailsQueryResult.failureCount < 3
    ) {
      memberDetailsQueryResult.refetch();
    }
  }, [enabled, memberDetailsQueryResult, memberDetails]);

  return {
    memberDetailsQueryResult,
    memberDetails,
  };
};

export default useMemberDetails;
